import { createContext, useContext, useEffect, useState } from "react";

const FiltersContext = createContext();


const getInitialFilterFromSession = (key) => {
  const savedFilter = sessionStorage.getItem(key);
  return savedFilter ? JSON.parse(savedFilter) : null;
};

export function FiltersProvider({ children }) {
  const [savedFilter, setSavedFilter] = useState(null);
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [isNegotiation, setIsNegotiation] = useState(false);
  const [isSales, setIsSales] = useState(false);
  const [isProposal, setIsProposal] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedType, setSelectedType] = useState();
  const [contratoTab, setContratoTab] = useState("main");

 const [lastContractFilter, setLastContractFilter] = useState(null);
  const [lastNegotiationFilter, setLastNegotiationFilter] = useState(null);
  const [lastSalesFilter, setLastSalesFilter] = useState(null);
  



  const handleTypeSelection = (type) => {
    setSelectedType(type);

    if (type === 1) {
      setIsProposal(false);
      setIsSales(false);
      setIsNegotiation(false);
    } else if (type === 2) {
      setIsProposal(true);
      setIsSales(false);
      setIsNegotiation(false);
    } else if (type === 3) {
      setIsProposal(false);
      setIsSales(true);
      setIsNegotiation(false);
    }

    setIsModalVisible(false);
  };

  const clearCacheForType = (type, enterpriseId) => {
    const cachePrefix = `cache_${type}_${enterpriseId}_`;
    for (const key in sessionStorage) {
      if (key.startsWith(cachePrefix)) {
        sessionStorage.removeItem(key);
      }
    }
    const filterKey = `last${type.charAt(0).toUpperCase() + type.slice(1)}Filter_${enterpriseId}`;
    sessionStorage.removeItem(filterKey);
  };

  return (
    <FiltersContext.Provider
      value={{
        savedFilter,
        setSavedFilter,
        selectedCustomers,
        setSelectedCustomers,
        isNegotiation,
        setIsNegotiation,
        isSales,
        setIsSales,
        isProposal,
        setIsProposal,
        isModalVisible,
        setIsModalVisible,
        selectedType,
        setSelectedType,
        contratoTab,
        setContratoTab,
        handleTypeSelection,
        lastContractFilter,
        setLastContractFilter,
        lastNegotiationFilter,
        setLastNegotiationFilter,
        lastSalesFilter,
        setLastSalesFilter,
        clearCacheForType,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
}

export function useFiltersContext() {
  return useContext(FiltersContext);
}